import React, { useEffect, useState } from 'react';
import { Image } from 'rebass';
import axios from 'axios';

export function renderPositionForVGBImage(position) {
    if ((position?.x === 0 || !position?.x) && (position?.y === 0 || !position?.y)) return null;

    return position;
}

export const getAspectRatio = (width) => {
    const vidWidth = width - 156; // 1436 - 156 = 1280
    return vidWidth / (16 / 9); // find 16/9 ratio height
};
export function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
}
// export function calculateAspectRatioFit(
//     srcWidth,
//     srcHeight,
//     maxWidth,
//     maxHeight = Infinity
// ) {
//     const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

//     const width = srcWidth * ratio;
//     const height = srcHeight * ratio;
//     const aspectRatio = width / height;

//     return { width, height, aspectRatio };
// }

export const useObjectURL = (file) => {
    const [fileSrc, setFileSrc] = useState(undefined);

    useEffect(() => {
        if (!fileSrc && file && typeof file === 'object') {
            setFileSrc(URL.createObjectURL(file));
        }
        return () => {
            if (fileSrc) {
                URL.revokeObjectURL(fileSrc);
            }
        };
    }, [file, setFileSrc, fileSrc]);

    if (!file) return undefined;

    return fileSrc;
};
export function ImageFromFileOrSrc({ file, src, ...props }) {
    const fileSrc = useObjectURL(file);
    const image = fileSrc || src;
    return <Image crossOrigin="anonymous" src={image} {...props} />;
}

export function scalePosition(position) {
    if (position === 0)
        return 40

    if (position < 3) return (position / 3) * 100;
    return position;
}
export function isFileOrBlob(variable) {
    return variable instanceof File || variable instanceof Blob;
}

export async function imageUrlToBlob(imageUrl) {
    try {
        const response = await axios.get(imageUrl, {
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        console.error('Error converting image to Blob:', error);
        return null;
    }
}